// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import { React, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';

// 
// ─── IMPORTING COMPONENTS ───────────────────────────────────────
//
import ModalScanStore from '../Modals/Qr/Scan/ModalScanStore';
import ModalScanConfirmation from '../Modals/Qr/Success/ModalScanConfirmation';
// SCAN INVERSE (2026-09-08) — conservés inertes, plus importés
// import ModalQrCode from '../Modals/Qr/User/ModalQrCode';
// import ModalReadQrCode from '../Modals/Qr/Scan/ModalReadQrCode';

// 
// ─── IMPORTING SVG ───────────────────────────────────────
//
import background from '../../assets/static/navbar-70.svg'
import { ReactComponent as ScanQr } from '../../assets/static/scanQr.svg'
// 
// ─── IMPORTING FONTAWESOME ICONS ───────────────────────────────────────
//
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse } from '@fortawesome/pro-regular-svg-icons'
import { faStore } from '@fortawesome/pro-regular-svg-icons'
import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import { faLock } from '@fortawesome/pro-regular-svg-icons'
import { faUser } from '@fortawesome/pro-regular-svg-icons'
import { faBarcode } from '@fortawesome/pro-regular-svg-icons'
import { faTag } from '@fortawesome/pro-regular-svg-icons';

// SCSS
import './NavigationFooter.scss'

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const NavigationFooter = () => {
  // 
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  // Modal
  const [openScan, setOpenScan] = useState(false)
  const [confirmation, setConfirmation] = useState(null)

  // Fontawesome init
  library.add(faHouse, faTag, faStore, faXmark, faLock, faUser, faBarcode)

  // Cookies
  const cookies = new Cookies();
  const userData = cookies.get(process.env.REACT_APP_USER_COOKIE);


  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <>
    {/* SCAN DU QR BOUTIQUE */}
    {openScan && <ModalScanStore
      open={openScan}
      onClose={() => setOpenScan(false)}
      onSuccess={(scan) => { setOpenScan(false); setConfirmation(scan) }}
    />}
    {/* CARTE DE CONFIRMATION */}
    {confirmation && <ModalScanConfirmation
      open={!!confirmation}
      scan={confirmation}
      onClose={() => setConfirmation(null)}
    />}

    <div className="bottom-appbar">
      <img loading="lazy" src={background} alt='background-NavBar' className='background-nav' />

      <div className="tabs">
        <div className="tab tab--left">
          <NavLink to='/' end className={({ isActive }) => isActive ? 'active' : ''}>
            <FontAwesomeIcon className='icons' icon="fa-regular fa-house" />Accueil
          </NavLink>
          <NavLink to='/offres' className={({ isActive }) => isActive ? 'active' : ''}>
            <FontAwesomeIcon className='icons' icon="fa-regular fa-tag" />Offres
          </NavLink>
        </div>
        <div className="tab tab--fab">
          {([1, 2, 4].includes(userData.role)) && <div className='fab' onClick={() => setOpenScan(!openScan)}>
            {!openScan ? <ScanQr className='scanQr' /> : <FontAwesomeIcon className='qr' icon="fa-solid fa-xmark" />}
          </div>}
        </div>
        <div className="tab tab--right">
          <NavLink to='/enseignes' className={({ isActive }) => isActive ? 'active' : ''}>
            <FontAwesomeIcon className='icons' icon="fa-regular fa-store" />Enseignes
          </NavLink>
          <NavLink to='/mon-compte' className={({ isActive }) => isActive ? 'active' : ''}> <FontAwesomeIcon className='icons' icon="fa-regular fa-user" /> Profil</NavLink>
        </div>
      </div>
    </div>
  </>
};

export default NavigationFooter;